import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAccount } from "../account/context";

declare var window: any;

export const GoogleAnalytics = () => {
  const location = useLocation();
  const { user } = useAccount();

  useEffect(() => {
    if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
        page_path: location.pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  useEffect(() => {
    if (typeof window.gtag === "function" && user) {
        window.gtag("set", "user_properties", {
        user_id: user.uniqueCode, // Replace with actual user ID
      });
    }
  }, [user]);

  return <></>;
};
